import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Shield } from 'lucide-react';

const PrivacyPolicyPage = () => {
  const { language } = useLanguage();

  const content = {
    ru: {
      title: 'Политика конфиденциальности',
      lastUpdated: 'Последнее обновление: 25 марта 2025 г.',
      intro: 'ТОО «Гипсовинил» (далее — «Компания», «мы») уважает вашу конфиденциальность и обязуется защищать ваши персональные данные в соответствии с Законом Республики Казахстан «О персональных данных и их защите».',
      sections: [
        {
          title: '1. Какие данные мы собираем',
          content: `Мы можем собирать следующие категории персональных данных:
• Контактная информация: имя, номер телефона, адрес электронной почты
• Данные компании: название организации, должность
• Техническая информация: IP-адрес, тип браузера, данные cookies
• Информация о заказах: история обращений, предпочтения по продукции`
        },
        {
          title: '2. Цели обработки данных',
          content: `Мы используем ваши персональные данные для:
• Обработки заявок и консультаций
• Выполнения договорных обязательств
• Улучшения качества наших услуг
• Отправки информационных материалов (с вашего согласия)
• Соблюдения требований законодательства РК`
        },
        {
          title: '3. Правовые основания обработки',
          content: `Обработка персональных данных осуществляется на основании:
• Вашего согласия
• Необходимости исполнения договора
• Соблюдения законодательных требований
• Законных интересов Компании`
        },
        {
          title: '4. Хранение и защита данных',
          content: `• Персональные данные хранятся на защищённых серверах
• Срок хранения — не более 5 лет с момента последнего взаимодействия
• Мы применяем технические и организационные меры защиты
• Доступ к данным имеют только уполномоченные сотрудники`
        },
        {
          title: '5. Ваши права',
          content: `В соответствии с законодательством РК вы имеете право:
• Получить информацию об обработке ваших данных
• Запросить исправление неточных данных
• Требовать удаления ваших данных
• Отозвать согласие на обработку данных
• Подать жалобу в уполномоченный орган`
        },
        {
          title: '6. Cookies',
          content: `Наш сайт использует cookies для:
• Обеспечения корректной работы сайта
• Анализа посещаемости и улучшения сервиса
• Персонализации контента

Вы можете отключить cookies в настройках браузера, но это может повлиять на функциональность сайта.`
        },
        {
          title: '7. Передача данных третьим лицам',
          content: `Мы не продаём ваши персональные данные. Данные могут передаваться:
• Партнёрам для выполнения заказов (дилеры, логистические компании)
• Государственным органам по запросу в соответствии с законом
• Техническим провайдерам для обеспечения работы сайта`
        },
        {
          title: '8. Контакты',
          content: `По вопросам обработки персональных данных обращайтесь:

ТОО «Гипсовинил»
БИН: 240140033968
Адрес: Казахстан, г. Астана, район Алматы, ул. Бұйрат, здание 12
Email: gipsovinilkz@gmail.com
Телефон: +7 747 665-1453`
        }
      ]
    },
    kz: {
      title: 'Құпиялылық саясаты',
      lastUpdated: 'Соңғы жаңарту: 2025 жылғы 25 наурыз',
      intro: '«Гипсовинил» ЖШС (бұдан әрі — «Компания», «біз») сіздің құпиялылығыңызды құрметтейді және Қазақстан Республикасының «Дербес деректер және оларды қорғау туралы» Заңына сәйкес сіздің дербес деректеріңізді қорғауға міндеттенеді.',
      sections: [
        {
          title: '1. Біз қандай деректерді жинаймыз',
          content: `Біз дербес деректердің келесі санаттарын жинай аламыз:
• Байланыс ақпараты: аты, телефон нөмірі, электрондық пошта мекенжайы
• Компания деректері: ұйым атауы, лауазымы
• Техникалық ақпарат: IP-мекенжай, браузер түрі, cookies деректері
• Тапсырыс туралы ақпарат: өтініштер тарихы, өнім таңдаулары`
        },
        {
          title: '2. Деректерді өңдеу мақсаттары',
          content: `Біз сіздің дербес деректеріңізді мына мақсаттарда пайдаланамыз:
• Өтініштер мен кеңестерді өңдеу
• Шарттық міндеттемелерді орындау
• Қызметтеріміздің сапасын жақсарту
• Ақпараттық материалдар жіберу (сіздің келісіміңізбен)
• ҚР заңнамасының талаптарын сақтау`
        },
        {
          title: '3. Өңдеудің құқықтық негіздері',
          content: `Дербес деректерді өңдеу мына негіздерде жүзеге асырылады:
• Сіздің келісіміңіз
• Шартты орындау қажеттілігі
• Заңнамалық талаптарды сақтау
• Компанияның заңды мүдделері`
        },
        {
          title: '4. Деректерді сақтау және қорғау',
          content: `• Дербес деректер қорғалған серверлерде сақталады
• Сақтау мерзімі — соңғы өзара әрекеттесуден бастап 5 жылдан аспайды
• Біз техникалық және ұйымдастырушылық қорғау шараларын қолданамыз
• Деректерге тек уәкілетті қызметкерлер қол жеткізе алады`
        },
        {
          title: '5. Сіздің құқықтарыңыз',
          content: `ҚР заңнамасына сәйкес сізде мынадай құқықтар бар:
• Деректеріңізді өңдеу туралы ақпарат алу
• Дәл емес деректерді түзетуді сұрау
• Деректеріңізді жоюды талап ету
• Деректерді өңдеуге келісімді қайтарып алу
• Уәкілетті органға шағым беру`
        },
        {
          title: '6. Cookies',
          content: `Біздің сайт cookies файлдарын мына мақсаттарда пайдаланады:
• Сайттың дұрыс жұмыс істеуін қамтамасыз ету
• Кіру статистикасын талдау және қызметті жақсарту
• Мазмұнды жекелендіру

Сіз браузер параметрлерінде cookies файлдарын өшіре аласыз, бірақ бұл сайт функционалдығына әсер етуі мүмкін.`
        },
        {
          title: '7. Деректерді үшінші тұлғаларға беру',
          content: `Біз сіздің дербес деректеріңізді сатпаймыз. Деректер мыналарға берілуі мүмкін:
• Тапсырыстарды орындау үшін серіктестерге (дилерлер, логистикалық компаниялар)
• Заңға сәйкес сұрау бойынша мемлекеттік органдарға
• Сайт жұмысын қамтамасыз ету үшін техникалық провайдерлерге`
        },
        {
          title: '8. Байланыс',
          content: `Дербес деректерді өңдеу мәселелері бойынша хабарласыңыз:

«Гипсовинил» ЖШС
БСН: 240140033968
Мекенжай: Қазақстан, Астана қ., Алматы ауданы, Бұйрат к-сі, 12 ғимарат
Email: gipsovinilkz@gmail.com
Телефон: +7 747 665-1453`
        }
      ]
    },
    en: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: March 25, 2025',
      intro: 'GIPSOVINIL LLP (hereinafter — "Company", "we") respects your privacy and is committed to protecting your personal data in accordance with the Law of the Republic of Kazakhstan "On Personal Data and Their Protection".',
      sections: [
        {
          title: '1. What Data We Collect',
          content: `We may collect the following categories of personal data:
• Contact information: name, phone number, email address
• Company data: organization name, position
• Technical information: IP address, browser type, cookies data
• Order information: inquiry history, product preferences`
        },
        {
          title: '2. Purposes of Data Processing',
          content: `We use your personal data to:
• Process inquiries and consultations
• Fulfill contractual obligations
• Improve the quality of our services
• Send informational materials (with your consent)
• Comply with RK legislation requirements`
        },
        {
          title: '3. Legal Basis for Processing',
          content: `Personal data processing is carried out based on:
• Your consent
• Necessity to perform a contract
• Compliance with legal requirements
• Legitimate interests of the Company`
        },
        {
          title: '4. Data Storage and Protection',
          content: `• Personal data is stored on secure servers
• Storage period — no more than 5 years from the last interaction
• We apply technical and organizational protection measures
• Only authorized employees have access to data`
        },
        {
          title: '5. Your Rights',
          content: `In accordance with RK legislation, you have the right to:
• Receive information about the processing of your data
• Request correction of inaccurate data
• Demand deletion of your data
• Withdraw consent to data processing
• File a complaint with the authorized body`
        },
        {
          title: '6. Cookies',
          content: `Our website uses cookies to:
• Ensure proper website operation
• Analyze traffic and improve service
• Personalize content

You can disable cookies in your browser settings, but this may affect website functionality.`
        },
        {
          title: '7. Data Transfer to Third Parties',
          content: `We do not sell your personal data. Data may be transferred to:
• Partners to fulfill orders (dealers, logistics companies)
• Government authorities upon request in accordance with the law
• Technical providers to ensure website operation`
        },
        {
          title: '8. Contacts',
          content: `For questions about personal data processing, please contact:

GIPSOVINIL LLP
BIN: 240140033968
Address: Kazakhstan, Astana, Almaty district, Buyrat street, building 12
Email: gipsovinilkz@gmail.com
Phone: +7 747 665-1453`
        }
      ]
    },
    ar: {
      title: 'سياسة الخصوصية',
      lastUpdated: 'آخر تحديث: 25 مارس 2025',
      intro: 'تحترم شركة GIPSOVINIL LLP (المشار إليها فيما يلي بـ "الشركة"، "نحن") خصوصيتك وتلتزم بحماية بياناتك الشخصية وفقاً لقانون جمهورية كازاخستان "بشأن البيانات الشخصية وحمايتها".',
      sections: [
        {
          title: '1. البيانات التي نجمعها',
          content: `قد نجمع الفئات التالية من البيانات الشخصية:
• معلومات الاتصال: الاسم، رقم الهاتف، البريد الإلكتروني
• بيانات الشركة: اسم المؤسسة، المسمى الوظيفي
• المعلومات التقنية: عنوان IP، نوع المتصفح، بيانات ملفات تعريف الارتباط
• معلومات الطلبات: سجل الاستفسارات، تفضيلات المنتجات`
        },
        {
          title: '2. أغراض معالجة البيانات',
          content: `نستخدم بياناتك الشخصية من أجل:
• معالجة الاستفسارات وتقديم الاستشارات
• الوفاء بالالتزامات التعاقدية
• تحسين جودة خدماتنا
• إرسال المواد الإعلامية (بموافقتك)
• الامتثال لمتطلبات تشريعات جمهورية كازاخستان`
        },
        {
          title: '3. الأساس القانوني للمعالجة',
          content: `تُجرى معالجة البيانات الشخصية استناداً إلى:
• موافقتك الصريحة
• ضرورة تنفيذ العقد
• الامتثال للمتطلبات القانونية
• المصالح المشروعة للشركة`
        },
        {
          title: '4. تخزين البيانات وحمايتها',
          content: `• تُخزَّن البيانات الشخصية على خوادم آمنة
• مدة التخزين — لا تزيد على 5 سنوات من آخر تفاعل
• نطبّق تدابير الحماية التقنية والتنظيمية
• لا يملك صلاحية الوصول إلى البيانات إلا الموظفون المخوّلون`
        },
        {
          title: '5. حقوقك',
          content: `وفقاً لتشريعات جمهورية كازاخستان، يحق لك:
• الحصول على معلومات حول معالجة بياناتك
• طلب تصحيح البيانات غير الدقيقة
• المطالبة بحذف بياناتك
• سحب الموافقة على معالجة البيانات
• تقديم شكوى إلى الجهة المختصة`
        },
        {
          title: '6. ملفات تعريف الارتباط (Cookies)',
          content: `يستخدم موقعنا الإلكتروني ملفات تعريف الارتباط من أجل:
• ضمان التشغيل السليم للموقع
• تحليل حركة الزيارات وتحسين الخدمة
• تخصيص المحتوى

يمكنك تعطيل ملفات تعريف الارتباط من إعدادات المتصفح، غير أن ذلك قد يؤثر على وظائف الموقع.`
        },
        {
          title: '7. نقل البيانات إلى أطراف ثالثة',
          content: `نحن لا نبيع بياناتك الشخصية. قد تُنقل البيانات إلى:
• الشركاء لتنفيذ الطلبات (الموزعون، شركات الخدمات اللوجستية)
• الجهات الحكومية بناءً على الطلب وفقاً للقانون
• مزودي الخدمات التقنية لضمان تشغيل الموقع`
        },
        {
          title: '8. معلومات الاتصال',
          content: `للاستفسار عن معالجة البيانات الشخصية، يرجى التواصل معنا:

GIPSOVINIL LLP
BIN: 240140033968
العنوان: كازاخستان، أستانا، حي ألماتي، شارع بويرات، مبنى 12
البريد الإلكتروني: gipsovinilkz@gmail.com
الهاتف: +7 747 665-1453`
        }
      ]
    }
  };

  const t = content[language] || content.en || content.ru;

  return (
    <div className="min-h-screen bg-[#F5F5F0]">
      {/* Header */}
      <section className="py-12 bg-[#061d36] text-white">
        <div className="container mx-auto px-4 text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t.title}</h1>
          <p className="text-blue-200">{t.lastUpdated}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-sm">
            <p className="text-lg text-[#061d36] mb-8 leading-relaxed">{t.intro}</p>
            
            {t.sections.map((section, idx) => (
              <div key={idx} className="mb-8">
                <h2 className="text-xl font-bold text-[#061d36] mb-4">{section.title}</h2>
                <p className="text-[#061d36]/80 whitespace-pre-line leading-relaxed">{section.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
